import { NavigateFunction } from 'react-router-dom';
import { toast } from 'react-toastify';
import { movePath, planMovesPath, productRootPath } from '@features/products/productRoutes';


export const goToRoute = (route: string | null, navigate: NavigateFunction) => {
  if (route) navigate(route);
  else toast.error(`No route was specified!`, { toastId: 'navigation-missing-target' });
};

export const goToPreviousPage = (navigate: NavigateFunction) => {
  navigate(-1);
};

export const goToNextPage = (navigate: NavigateFunction) => {
  navigate(1);
};

export const goToMovesIndex = (navigate: NavigateFunction) => {
  navigate(productRootPath('moves'));
};

export const goToLanesIndex = (navigate: NavigateFunction) => {
  navigate(`/lanes`);
};

export const goToLocationsIndex = (navigate: NavigateFunction) => {
  navigate(`/locations`);
};

export const goToLocationDetails = (navigate: NavigateFunction, locationId: number) => {
  navigate(`/locations/${locationId}`);
};

export const goToMovePlanner = (navigate: NavigateFunction) => {
  navigate(planMovesPath());
};

export const goToMoveDetails = (moveId: string | null, edit = false, navigate: NavigateFunction) => {
  if (moveId && edit) {
    navigate(movePath(moveId), { state: { editMode: true } });
  } else if (moveId) {
    navigate(movePath(moveId));
  } else {
    toast.error(`No move ID was specified!`, { toastId: 'navigation-missing-target' });
  }
};

export const goToInvoice = (
  invoiceId: string | null,
  customerId: string | null,
  foldId: string | null,
  navigate: NavigateFunction
) => {
  if (invoiceId) localStorage.setItem('invoice-id', invoiceId);
  if (customerId) localStorage.setItem('invoice-customer-id', customerId);
  if (foldId) localStorage.setItem('invoice-fold-id', foldId);
  navigate(`/invoices`);
};

export const goToUserDetails = (userId: string | null, navigate: NavigateFunction) => {
  if (userId) navigate(`/users/${userId}`);
  else toast.error(`No user ID was specified!`, { toastId: 'navigation-missing-target' });
};

export const goToSettings = (navigate: NavigateFunction) => {
  navigate(`/settings`);
};
